// ./games/crash/state/phases/BetLockPhase.ts

import type { IPhase, PhaseContext } from './IPhase';
import { isStompTick, StompMessage } from '@core/Web/types/StompMessage';
import { FlyingPhase } from './FlyingPhase';

export class BetLockPhase implements IPhase {
  constructor(private context: PhaseContext) {}

  onEnter(): void {
    console.log('[Phase] ==> Entering BET_LOCK phase.');
    this.context.store.getState().setPhase('BET_LOCK');
  }

  onExit(): void {
    console.log('[Phase] <== Exiting BET_LOCK phase.');
  }

  // MODIFIED: Added logic to handle the first tick message
  handleMessage(message: StompMessage): void {
    if (isStompTick(message) && message.multiplier >= 1.0) {
      console.log(
        `[Phase][BetLock] Received first tick > 1.0 (${message.multiplier}x). Transitioning to FLYING.`
      );
      this.context.manager.transitionTo(new FlyingPhase(this.context));
    }
  }

  update(_deltaTime: number): void {}
}
